import { useEffect } from 'react';
import { useStore } from '../lib/store.ts';

export function ToastContainer() {
  const toasts = useStore((s) => s.toasts);
  const removeToast = useStore((s) => s.removeToast);

  return (
    <div className="fixed top-4 right-4 z-50 flex flex-col gap-2">
      {toasts.map((toast) => (
        <ToastItem key={toast.id} id={toast.id} message={toast.message} type={toast.type} onDismiss={removeToast} />
      ))}
    </div>
  );
}

function ToastItem({ id, message, type, onDismiss }: Readonly<{ id: string; message: string; type: 'error' | 'success'; onDismiss: (id: string) => void }>) {
  useEffect(() => {
    const timer = setTimeout(() => onDismiss(id), 4000);
    return () => clearTimeout(timer);
  }, [id, onDismiss]);

  return (
    <div
      className={`px-4 py-3 rounded-lg shadow-lg text-sm font-medium flex items-center gap-2 animate-[slideIn_0.3s_ease-out] ${
        type === 'error'
          ? 'bg-red-900/90 text-red-200 border border-red-700'
          : 'bg-green-900/90 text-green-200 border border-green-700'
      }`}
    >
      <span>{type === 'error' ? '✕' : '✓'}</span>
      <span>{message}</span>
      <button onClick={() => onDismiss(id)} className="ml-2 opacity-60 hover:opacity-100">×</button>
    </div>
  );
}
